export const dataSetJustica = [
  {
    nome: "Estadual",
    value:"estadual",
    marcado: false,
    fixo: false,
  },
  {
    nome: "Federal",
    value:"federal",
    marcado: false,
    fixo: false,
  },
  {
    nome: "Trabalhista",
    value:"trabalhista",
    marcado: false,
    fixo: false,
  }
];
